export const SET_VEHICLE_NUMBER = "SET_VEHICLE_NUMBER";
export const GET_CUST_DATA = "GET_CUST_DATA";
export const IS_SME = "IS_SME";
export const SET_VEHICLE_DETAILS = "SET_VEHICLE_DETAILS";
export const UPDATE_VEHICLE_DETAILS = "UPDATE_VEHICLE_DETAILS";
export const SET_POLICY_DETAILS = "SET_POLICY_DETAILS";
export const SET_PROPOSAL_DETAILS = "SET_PROPOSAL_DETAILS";
export const GET_PROPOSAL_DETAILS = "GET_PROPOSAL_DETAILS";
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const UPDATE_CUSTOMER_DETAILS = "UPDATE_CUSTOMER_DETAILS";
export const GET_VEHICLE_DETAILS = "GET_VEHICLE_DETAILS";
export const UPDATE_SINGLE_VEHICLE_DETAILS = "UPDATE_SINGLE_VEHICLE_DETAILS";
export const REMOVE_VEHICLE = "REMOVE_VEHICLE";
export const SET_DRIVER = "SET_DRIVER";
export const REMOVE_DRIVER = "REMOVE_DRIVER";
export const SET_ACTIVE_PROGRAM = "SET_ACTIVE_PROGRAM";
export const SET_ACTIVE_VEHICLE = "SET_ACTIVE_VEHICLE";
export const SET_VEHICLE_FEATURES = "SET_VEHICLE_FEATURES";
export const UPDATE_LOCAL_DRIVER = "UPDATE_LOCAL_DRIVER";
export const SET_OTP = "SET_OTP";
export const SET_SELECTED_VEHICLE = "SET_SELECTED_VEHICLE";
export const SET_QUOTATION = "SET_QUOTATION";
export const UPDATE_QUOTATION_REQUEST = "UPDATE_QUOTATION_REQUEST";
export const UPDATE_FORMS_VALUES = "UPDATE_FORMS_VALUES";
export const UPDATE_FORMS_STATUS = "UPDATE_FORMS_STATUS";
export const SET_TEMP_VEHICLES_ARR = "SET_TEMP_VEHICLES_ARR";
export const SET_TMX = "SET_TMX";
export const SET_TMX_VEHICLE_DETAILS = "SET_TMX_VEHICLE_DETAILS";
export const SAVE_QUOTATION_REQ_DATA = "SAVE_QUOTATION_REQ_DATA";
export const CHANGE_DEDUCTABLE = "CHANGE_DEDUCTABLE";
export const PAYMENTFAILED = "PAYMENTFAILED";
export const CHANGE_DRIVER_REGISTERED = "CHANGE_DRIVER_REGISTERED";
export const CHANGE_DRIVER_SELECTED = "CHANGE_DRIVER_SELECTED";
export const LEADGEN = "LEADGEN";
export const RESET = "RESET"
export const STORE_OTP = "STORE_OTP"
export const SAVE_TOTAL_PRICE = "SAVE_TOTAL_PRICE"
export const UPDATE_INCEPTION_DATE = "UPDATE_INCEPTION_DATE"
export const TAWUNIYA_LEAD = "TAWUNIYA_LEAD"